import { PlatformLocation, registerLocaleData, } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { Injector, } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgcCookieConsentConfig, } from 'ngx-cookieconsent';
import { MarkedOptions, MarkedRenderer } from 'ngx-markdown';
import { IT_i18n, EN_i18n } from 'ngx-uaa';
import { DEPLOY_URL } from '../deploy-url';
import { environment } from '../environments/environment';
import { AuthStrategiesService, } from './modules/shared/features/auth-strategies';
import { AuthService } from './modules/shared/services/http/auth.service';
import { RealmSettingService } from './modules/shared/services/http/realm-setting.service';
registerLocaleData(localeIt, 'it-IT');
const password_pattern = {
    re: '^(?=.*[a-z])(?=.*[A-Z]).{8,}$',
    flag: '',
};
export function initializeAuthService(authService) {
    return () => {
        return authService.Init();
    };
}
import * as itJson from '../assets/i18n/it.json';
import * as enJson from '../assets/i18n/en.json';
function deepMerge(target, source) {
    const result = Object.assign({}, target);
    for (const key of Object.keys(source)) {
        if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])
            && target[key] && typeof target[key] === 'object' && !Array.isArray(target[key])) {
            result[key] = deepMerge(target[key], source[key]);
        }
        else {
            result[key] = source[key];
        }
    }
    return result;
}
export function initializeTranslations(translate) {
    return () => {
        const itLocal = itJson.default || itJson;
        const enLocal = enJson.default || enJson;
        translate.setTranslation('it', deepMerge(IT_i18n, itLocal), true);
        translate.setTranslation('en', deepMerge(EN_i18n, enLocal), true);
        translate.addLangs(['it', 'en']);
        translate.setDefaultLang('it');
        const savedLang = localStorage.getItem('lang');
        const browserLang = translate.getBrowserLang();
        const lang = savedLang || (browserLang.match(/it|en/) ? browserLang : 'it');
        return translate.use(lang).toPromise();
    };
}
export function initializeConfigs(realmSettingService) {
    return () => {
        return realmSettingService.setConfigs();
    };
}
export function initAuthProviders(authProvidersService) {
    return () => authProvidersService.availableStrategies.fetch().toPromise();
}
export function getBaseHref(platformLocation) {
    return platformLocation.getBaseHrefFromDOM();
}
export function initReturnUrl(injector) {
    return () => {
        const hasReturnUrl = new RegExp(/returnUrl=([^&#=]*)/).exec(window.location.search);
        if (hasReturnUrl && hasReturnUrl.length > 1) {
            const returnUrl = hasReturnUrl[1];
            sessionStorage.setItem('returnUrl', decodeURIComponent(returnUrl));
        }
        return Promise.resolve(true);
    };
}
const cookieConfig = {
    cookie: {
        domain: DEPLOY_URL.toString(),
    },
    palette: {
        popup: {
            background: '#2d5575',
            text: '#ffffff',
            link: '#ffffff',
        },
        button: {
            background: '#f1d600',
        },
    },
    theme: 'edgeless',
    type: 'info',
    autoAttach: false,
    content: {
        message: '',
        cookiePolicyLink: '',
        cookiePolicyHref: '/page/public/cookie-policy',
        dismiss: '',
    },
    elements: {
        messagelink: `
      <span id="cookieconsent:desc" class="cc-message">{{message}}
      <a aria-label="learn more about cookies" tabindex="0" class="cc-link"
      href="{{cookiePolicyHref}}" target="_blank">{{cookiePolicyLink}}</a>
      </span>`,
    },
};
export function markedOptionsFactory() {
    const renderer = new MarkedRenderer();
    renderer.link = (href, title, text) => {
        const titlePart = title ? `title="${title}"` : '';
        return `<a href="${href}" ${titlePart} target="_blank">${text}</a>`;
    };
    return {
        renderer,
    };
}
const ɵ0 = environment.uaaRecaptchaKey, ɵ1 = {
    pattern: new RegExp(password_pattern.re, password_pattern.flag),
    helper: 'La password deve contenere almeno una lettera maiuscola, una minuscola e una lunghezza di almeno 8 caratteri.',
};
export class AppModule {
    constructor(deployUrl, baseHref) {
        this.deployUrl = deployUrl;
        this.baseHref = baseHref;
    }
}
export { ɵ0, ɵ1 };
